// extracted by mini-css-extract-plugin
module.exports = {"root":"az_GQ","st-skeleton-pulse":"az_HQ","no-animation":"az_IQ"};